import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {useReservation} from 'context/reservation';
import {useErrorToast} from 'hooks/common';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {deriveGuestGroupStats} from '@chekin/shared/guest-form';
import {API} from '@chekin/api';
import {useIVComputedDetails} from './useIVComputedDetails';

const guestGroupQueryOptions = (guestGroupId?: string) => ({
  queryKey: [QUERY_CACHE_KEYS.guestGroup, guestGroupId],
  queryFn: () => API.guestGroup.getGuestGroup(guestGroupId || ''),
  staleTime: 10_000,
  gcTime: 10_000,
  retryOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
});

function useGuestGroup() {
  const {isSuccessSDK} = useChekinSDK();
  const {data: reservation, isLoading: isLoadingReservation} = useReservation();
  const {isIVEnabled} = useIVComputedDetails();
  const guestGroupId = reservation?.guest_group_id;

  const {data, isLoading, isFetching, error, isSuccess} = useQuery({
    ...guestGroupQueryOptions(guestGroupId),
    enabled: isSuccessSDK && Boolean(guestGroupId),
  });

  useErrorToast(error, {
    notFoundMessage: 'Requested guests group not found',
    onlyMounted: true,
  });

  const stats = deriveGuestGroupStats(data, isIVEnabled);

  return {
    guestGroup: data,
    isLoading: isLoading || isLoadingReservation,
    isFetching: isFetching,
    ...stats,
    isSuccess,
  };
}

export {guestGroupQueryOptions, useGuestGroup};
